/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	var $win = jQuery(window),
		$body = jQuery('main');


	jQuery(".mailing-list a").on("click", function(){
		jQuery(".mask").addClass("active");

		jQuery(".open").removeClass('opened');
		jQuery(".c-hamburger").removeClass('is-active');
	});
	
	// Function for close the Modal
	
	function closeModal(){
		jQuery(".mask").removeClass("active");
	}
	
	// Call the closeModal function on the clicks/keyboard
	
	jQuery(".close, .mask").on("click", function(){
		closeModal();
	});
	
	jQuery(document).keyup(function(e) {
		if (e.keyCode == 27) {
		closeModal();
		}
	});

		jQuery(function(){jQuery('a[href^="#"]').click(function(){var target=jQuery(this).attr('href');jQuery('html, body').animate({scrollTop:jQuery(target).offset().top},800); if(window.outerWidth < 425){jQuery(".hide-for-desktop, .off-canvas-content").trigger("click");}});});


		jQuery('#main-nav > li a').each(
			function(){
				var innerText = jQuery(this).html()
				jQuery(this).html(`<span>${innerText}</span>`);
				jQuery(this).addClass('link link--leda');
				jQuery(this).attr('data-text', innerText);
			});

			// jQuery('#main-nav > li a').each(
			// 	function(){
			// 		jQuery(this).append('<svg class="link__graphic link__graphic--stroke link__graphic--scribble" width="100%" height="9" viewBox="0 0 101 9"><path d="M.426 1.973C4.144 1.567 17.77-.514 21.443 1.48 24.296 3.026 24.844 4.627 27.5 7c3.075 2.748 6.642-4.141 10.066-4.688 7.517-1.2 13.237 5.425 17.59 2.745C58.5 3 60.464-1.786 66 2c1.996 1.365 3.174 3.737 5.286 4.41 5.423 1.727 25.34-7.981 29.14-1.294" pathLength="1"/></svg>');
			// 	});

		jQuery('#terms').css("font-size", 14 + "px");

		var outerLocationDiv = '<div class="live-col-container"></div>';
	var outerTicketDiv = '<div class="live-ticket-container"></div>';
	var outerContentDiv = '<div class="live-location"></div>';

	jQuery('.umg_live_table tr').each(function() {
		jQuery(this).last().append(outerLocationDiv);
	});

	if(jQuery('.umg_live_rsvp').html() !== undefined){
		if(jQuery('.umg_live_rsvp').html().length < 1) {
			jQuery('.umg_live_rsvp').css('display', 'none')
		}
	}


	jQuery('.live-col-container').each(function() {
		var nearestDate = jQuery(this).siblings(".umg_live_date");
		jQuery(this).append(nearestDate);
		var nearestVenue = jQuery(this).siblings(".umg_live_venue");
		jQuery(this).append(nearestVenue);
	
	  });

	  jQuery('.umg_live_table tr').each(function() {
		jQuery(this).last().append(outerContentDiv);
	  });


	  jQuery('.umg_live_table tr').each(function() {
		jQuery(this).last().append(outerTicketDiv);
	  });

		jQuery('.live-ticket-container').each(function() {
			var nearestVenue = jQuery(this).siblings(".umg_live_tickets");
			jQuery(this).append(nearestVenue);
			var nearestLocation = jQuery(this).siblings(".umg_live_rsvp");
			jQuery(this).append(nearestLocation);
	
		  });

		  jQuery('.live-location').each(function() {
			var nearestLocation = jQuery(this).siblings(".umg_live_location");
			jQuery(this).append(nearestLocation);
		  });
	


		var toggles = document.querySelectorAll(".c-hamburger");

		for (var i = toggles.length - 1; i >= 0; i--) {
		var toggle = toggles[i];
		toggleHandler(toggle);
		};

		function toggleHandler(toggle) {
		toggle.addEventListener("click", function(e) {
			e.preventDefault();
			if (this.classList.contains("is-active") === true) {
			this.classList.remove("is-active");
			jQuery('.open').removeClass('opened');
			} else {
			this.classList.add("is-active");
			jQuery(".open").addClass('opened');
			}
		});
		}
		jQuery(".sub-menu li a").click(function(event) {
		jQuery(".open").removeClass('opened');
		jQuery(".c-hamburger").removeClass('is-active');
		});
	

		var s,
		spanizeLetters = {
		  settings: {
			letters: jQuery('.main-home .section-header h2'),
		  },
		  init: function() {
			s = this.settings;
			this.bindEvents();
		  },
		  bindEvents: function(){
			s.letters.html(function (i, el) {
			  //spanizeLetters.joinChars();
			  var spanizer = jQuery.trim(el).split("");
			  return '<span>' + spanizer.join('</span><span>') + '</span>';
			});
		  },
		};

		spanizeLetters.init();



	

	// var containerDiv = '<div class="form-inputs"></div>';	
	// jQuery(containerDiv).insertBefore('.ae-cform-item-email');
	// jQuery('.ae-cform-item-email').appendTo('.form-inputs');
	// jQuery('.ae-cform-item-country').appendTo('.form-inputs');

	// jQuery('.ae-cform-optins-container').insertAfter('.cform-required-field');
	// jQuery('.form-policy').insertAfter('.ae-cform-optins-container');

	jQuery("#ae-cform-input-reg-email-1").attr("placeholder", "email");
	jQuery("#ae-cform-input-reg-country-1").attr("placeholder", "country")

	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	// jQuery(window).on('load', function() {
		jQuery('#ae-cform-input-reg-email-1').attr('placeholder', 'Email');

		jQuery('.top-bar .menu-bars').on('click', function() {
			jQuery(this).find('.fas').toggleClass('fa-times');
		});
		jQuery('.js-off-canvas-overlay').on('click', function() {
			jQuery('.top-bar .menu-bars .fas').removeClass('fa-times');
		});

		jQuery('.js-subscribe a').on('click', function(e) {
			e.preventDefault();

			var $target = jQuery(this).attr('href');

			jQuery('html, body').animate({
				scrollTop: jQuery($target).offset().top
			}, 800);

			if ( jQuery(this).parents('.off-canvas') ) {
				jQuery('.js-off-canvas-overlay').trigger('click');
			}
		});
		

		if( $body.hasClass('main-home') ) {
			var $banner = jQuery('.js-banner'),
				$videos = jQuery('.js-video-list'),
				$products = jQuery('.js-merch-list'),
				$releases = jQuery('.js-release-list'),
				$releases = jQuery('.js-release-list'),
				$news = jQuery('.js-news-list'),
				$menu = jQuery('#main-nav li a');

			// $menu.on('click', function(e) {
			// 	var $title = jQuery(this).attr('title').toLowerCase();

			// 	if($title) {
			// 		e.preventDefault();

			// 		jQuery('.menu-primary li').removeClass('active');
			// 		jQuery(this).parent().addClass('active');

			// 		jQuery('html, body').animate({
			// 			scrollTop: jQuery('.section-'+$title).offset().top - 64
			// 		}, 800);
			// 	}
			// });
			
			$banner.slick({
				dots: true,
				fade: true,
				cssEase: 'linear',
				responsive: [
				  {
					breakpoint: 815,
					settings: {
						arrows: false
					}
				  }
				]
			});

			jQuery('.section-banner').addClass('init');

            $banner.on('beforeChange', function(event, slick, currentSlide, nextSlide){
              $banner.addClass('is-sliding');
            });
      
            $banner.on('afterChange', function(event, slick, currentSlide){
              $banner.removeClass('is-sliding');
            });

			$releases.slick({
				dots: false,
				// fade: true,
				cssEase: 'linear',
				slidesToShow: 3,
				slidesToScroll: 1,
				responsive: [
					{
					  breakpoint: 815,
					  settings: {
						  slidesToShow: 1
					  }
					}
				  ]
			});

			$products.slick({
				dots: false,
				// fade: true,
				cssEase: 'linear',
				slidesToShow: 3,
				slidesToScroll: 1,
				responsive: [
					{
					  breakpoint: 815,
					  settings: {
						  slidesToShow: 1
					  }
					}
				  ]
			});

			$news.slick({
				dots: false,
				// fade: true,
				cssEase: 'linear',
				slidesToShow: 3,
				slidesToScroll: 1,
				responsive: [
					{
					  breakpoint: 815,
					  settings: {
						  slidesToShow: 1
					  }
					}
				  ]
			});

			// $releases.slick({
			// 	asNavFor: '.album-cover-list'
			// });

			// jQuery('.album-cover-list').slick({
			// 	arrows: false,
			// 	dots: false,
			// 	fade: true,
			// 	cssEase: 'linear',
			// 	asNavFor: '.js-release-list',
			// 	focusOnSelect: true
			// });

            // $releases.on('afterChange', function(event, slick, currentSlide){
            //   $releases.addClass('slided');
            // });

			$videos.slick({
				dots: false,
				fade: true,
				cssEase: 'linear',
				slidesToShow: 1,
				slidesToScroll: 1,
				// responsive: [
				// 	{
				// 	  breakpoint: 815,
				// 	  settings: {
				// 		  slidesToShow: 1
				// 	  }
				// 	}
				//   ]
			});
      
            $videos.on('afterChange', function(event, slick, currentSlide){
              $videos.addClass('slided');
            });


			jQuery('.article-video .button-yt').on('click', function(e) {
				e.preventDefault();
		
				var youtubeID = jQuery(this).data('id'),
					embedCode = "<div class='media-youtube-video'><iframe src='https://www.youtube.com/embed/" + youtubeID + "?showinfo=0&autohide=1&rel=0&autoplay=1&wmode=transparent' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div>",
					$parent = jQuery(this).parents('.type-video');
					
				if (!document.querySelector('.media-youtube-video')) {
					$parent.addClass('playing');
					$parent.append(embedCode);
					jQuery('.js-video-list').addClass('has-embed');
				} else {
					$parent.removeClass('playing');
					jQuery('.media-youtube-video').remove();
					jQuery('.js-video-list').removeClass('has-embed');
				}
			});
			jQuery('.js-video-list > button').on('click', function(){
				if (jQuery('.article-video').hasClass('playing')) {
					jQuery('.media-youtube-video').remove();
					jQuery('.article-video').removeClass('playing');
					jQuery('.js-video-list').removeClass('has-embed');
				}
			});

			jQuery('.js-intro-arrow').on('click', function(e){
				e.preventDefault();

				jQuery('html, body').animate({
					scrollTop: jQuery('.section-about').offset().top - 64
				}, 500);
			});

			jQuery('.main-home .section').each(function(){
				var self = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self.addClass('show');
					}, offset: '10%'
				});
			});

			jQuery('.main-home .article-video').each(function(){
				var self = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self.addClass('animate');
					}, offset: '10%'
				});
			});


			jQuery('.main-home .section-header h2').each(function(){
				var self = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self.addClass('js-spanize');
					}, 
					offset: '50%'
				});
			});

			jQuery('.main-home .header-container .see-all').each(function(){
				var self = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self.addClass('animate');
					}, 
					offset: '50%'
				});
			});

			jQuery('.main-home .section-contact .section-header h2').each(function(){
				var self = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self.addClass('js-spanize');
					}, 
					offset: '0'
				});
			});

			if( $win.width() < 480) {

				var waypoints = jQuery('.section-about').waypoint({
					handler: function(direction) {
					  if(direction == 'up') {
						jQuery('#top-bar-menu .logo').removeClass('show');
					  } else {
						jQuery('#top-bar-menu .logo').addClass('show');
					  }
					}, offset: '0'
				  });
			}
		}

		initScrollMagic();
			  function initScrollMagic() {
				// requirejs(['//cache.umusic.com/_sites/_halo/libraries/scrollmagic/js/ScrollMagic.min.js'],
				//   function(ScrollMagic) {
					// var body = jQuery("body");
					$body = jQuery('main');
			
					jQuery(".node--event").each(function(index) {
					  var controller = new ScrollMagic.Controller();
					  var currentEl = this;
			
					  var artistScene = new ScrollMagic.Scene({
						triggerElement: currentEl,
						offset: 0,
						triggerHook: .6,
						reverse: false
					  })
					  .setClassToggle(currentEl, 'animate-in')
					  .addTo(controller)
					});
			
					if($body.hasClass("main-home")) {
			
					  jQuery(".article-video").each(function(index) {
						var controller = new ScrollMagic.Controller();
						var currentEl = this;
			
						var videoScene = new ScrollMagic.Scene({
						  triggerElement: currentEl,
						  offset: 0,
						  triggerHook: .6,
						  reverse: true
						})
						.setClassToggle(currentEl, 'animate-in')
						.addTo(controller)
					  });

					  jQuery(".news-item").each(function(index) {
						var controller = new ScrollMagic.Controller();
						var currentEl = this;
			
						var videoScene = new ScrollMagic.Scene({
						  triggerElement: currentEl,
						  offset: 0,
						  triggerHook: .6,
						  reverse: true
						})
						.setClassToggle(currentEl, 'animate-in')
						.addTo(controller)
					  });

					  jQuery(".umg_live_table tr").each(function(index) {
						var controller = new ScrollMagic.Controller();
						var currentEl = this;
			
						var videoScene = new ScrollMagic.Scene({
						  triggerElement: currentEl,
						  offset: 0,
						  triggerHook: .6,
						  reverse: true
						})
						.setClassToggle(currentEl, 'animate-in')
						.addTo(controller)
					  });
			
					  jQuery(".release").each(function(index) {
						var controller = new ScrollMagic.Controller();
						var currentEl = this;
			
						var videoScene = new ScrollMagic.Scene({
						  triggerElement: currentEl,
						  offset: 0,
						  triggerHook: .6,
						  reverse: true
						})
						.setClassToggle(currentEl, 'animate-in')
						.addTo(controller)
					  });

					  jQuery(".merch-item").each(function(index) {
						var controller = new ScrollMagic.Controller();
						var currentEl = this;
			
						var videoScene = new ScrollMagic.Scene({
						  triggerElement: currentEl,
						  offset: 0,
						  triggerHook: .6,
						  reverse: true
						})
						.setClassToggle(currentEl, 'animate-in')
						.addTo(controller)
					  });
					
				//   }); // End scrollmagic requirejs
				}
			}
	
			var page = 2;
			
			jQuery( function($) {
			  jQuery( 'body' ).on( 'click', '.loadmore', function() {
				var data = {
				  'action': 'load_posts_by_ajax',
				  'page': page,
				  'security': blog.security
				};


				jQuery.post( blog.ajaxurl, data, function( response ) {			
					
				  if( $.trim(response) != '') {
					jQuery( '#ajax-posts' ).append( response );
					page++;
				  } else {
					jQuery( '.loadmore' ).hide();
					jQuery( ".no-more-post" ).html( "No More Post Available" );
				  }
				});
			  });
			});

			var page_videos = 2;
			
			jQuery( function($) {
			  jQuery( 'body' ).on( 'click', '.loadmore-videos', function() {
				var data = {
				  'action': 'load_posts_by_ajax_videos',
				  'page': page_videos,
				  'security': videos.security
				};


				jQuery.post( videos.ajaxurl, data, function( response ) {			
					
				  if( $.trim(response) != '') {
					jQuery( '.video-list' ).append( response );
					page_videos++;
				  } else {
					jQuery( '.loadmore-videos' ).hide();
					jQuery( ".no-more-post" ).html( "No More Post Available" );
				  }
				});
			  });
			});

			var page_releases = 2;
			
			jQuery( function($) {
			  jQuery( 'body' ).on( 'click', '.loadmore-releases', function() {
				var data = {
				  'action': 'load_posts_by_ajax_releases',
				  'page': page_releases,
				  'security': release.security
				};

				jQuery.post( release.ajaxurl, data, function( response ) {			
					
				  if( $.trim(response) != '') {
					jQuery( '.music-list' ).append( response );
					page_releases++;
				  } else {
					jQuery( '.loadmore-releases' ).hide();
					jQuery( ".no-more-post" ).html( "No More Post Available" );
				  }
				});
			  });
			});

			var page_news = 2;
			
			jQuery( function($) {
			  jQuery( 'body' ).on( 'click', '.loadmore-news', function() {
				var data = {
				  'action': 'load_posts_by_ajax_news',
				  'page': page_news,
				  'security': news.security
				};

				jQuery.post( news.ajaxurl, data, function( response ) {			
					
				  if( $.trim(response) != '') {
					jQuery( '.news-list' ).append( response );
					page_news++;
				  } else {
					jQuery( '.loadmore-news' ).hide();
					jQuery( ".no-more-post" ).html( "No More Post Available" );
				  }
				});
			  });
			});

// Select Change
	jQuery('#categoryFilter').change(function() {

		var category = jQuery(this).val();
	
		if (category === 'all') {
		jQuery('.video-parent > div').fadeIn(450);
		} else {
		jQuery('.video-parent > div').fadeIn(450);
		jQuery('.video-parent > div').not('.' + category).hide();
		}
	
	});

	jQuery('#categoryFilterMusic').change(function() {

		var category = jQuery(this).val();
	
		if (category === 'all') {
		jQuery('.release-parent > div').fadeIn(450);
		} else {
		jQuery('.release-parent > div').fadeIn(450);
		jQuery('.release-parent > div').not('.' + category).hide();
		}
	
	});

	jQuery.fn.tilt = function (options) {

        /**
         * RequestAnimationFrame
         */
        var requestTick = function requestTick() {
            if (this.ticking) return;
            requestAnimationFrame(updateTransforms.bind(this));
            this.ticking = true;
        };

        /**
         * Bind mouse movement evens on instance
         */
        var bindEvents = function bindEvents() {
            jQuery(this).on('mousemove', mouseMove);
            jQuery(this).on('mouseenter', mouseEnter);
            if (this.settings.reset) jQuery(this).on('mouseleave', mouseLeave);
        };

        /**
         * Set transition only on mouse leave and mouse enter so it doesn't influence mouse move transforms
         */
        var setTransition = function setTransition() {
            var _this = this;

            if (this.timeout !== undefined) clearTimeout(this.timeout);
            jQuery(this).css({ 'transition': this.settings.speed + 'ms ' + this.settings.easing });
            if (this.settings.glare) this.glareElement.css({ 'transition': 'opacity ' + this.settings.speed + 'ms ' + this.settings.easing });
            this.timeout = setTimeout(function () {
                jQuery(_this).css({ 'transition': '' });
                if (_this.settings.glare) _this.glareElement.css({ 'transition': '' });
            }, this.settings.speed);
        };

        /**
         * When user mouse enters tilt element
         */
        var mouseEnter = function mouseEnter(event) {
            this.ticking = false;
            jQuery(this).css({ 'will-change': 'transform' });
            setTransition.call(this);

            // Trigger change event
            jQuery(this).trigger("tilt.mouseEnter");
        };

        /**
         * Return the x,y position of the muose on the tilt element
         * @returns {{x: *, y: *}}
         */
        var getMousePositions = function getMousePositions(event) {
            if (typeof event === "undefined") {
                event = {
                    pageX: jQuery(this).offset().left + jQuery(this).outerWidth() / 2,
                    pageY: jQuery(this).offset().top + jQuery(this).outerHeight() / 2
                };
            }
            return { x: event.pageX, y: event.pageY };
        };

        /**
         * When user mouse moves over the tilt element
         */
        var mouseMove = function mouseMove(event) {
            this.mousePositions = getMousePositions(event);
            requestTick.call(this);
        };

        /**
         * When user mouse leaves tilt element
         */
        var mouseLeave = function mouseLeave() {
            setTransition.call(this);
            this.reset = true;
            requestTick.call(this);

            // Trigger change event
            jQuery(this).trigger("tilt.mouseLeave");
        };

        /**
         * Get tilt values
         *
         * @returns {{x: tilt value, y: tilt value}}
         */
        var getValues = function getValues() {
            var width = jQuery(this).width();
            var height = jQuery(this).height();
            var left = jQuery(this).offset().left;
            var top = jQuery(this).offset().top;
			if(this.mousePositions){
            var percentageX = (this.mousePositions.x - left) / width;
            var percentageY = (this.mousePositions.y - top) / height;
            // x or y position inside instance / width of instance = percentage of position inside instance * the max tilt value
            var tiltX = (this.settings.maxTilt / 2 - percentageX * this.settings.maxTilt).toFixed(2);
            var tiltY = (percentageY * this.settings.maxTilt - this.settings.maxTilt / 2).toFixed(2);
            // angle
            var angle = Math.atan2(this.mousePositions.x - (left + width / 2), -(this.mousePositions.y - (top + height / 2))) * (180 / Math.PI);
            // Return x & y tilt values
            return { tiltX: tiltX, tiltY: tiltY, 'percentageX': percentageX * 100, 'percentageY': percentageY * 100, angle: angle };}
        };

        /**
         * Update tilt transforms on mousemove
         */
        var updateTransforms = function updateTransforms() {
            this.transforms = getValues.call(this);

            if (this.reset) {
                this.reset = false;
                jQuery(this).css('transform', 'perspective(' + this.settings.perspective + 'px) rotateX(0deg) rotateY(0deg)');

                // Rotate glare if enabled
                if (this.settings.glare) {
                    this.glareElement.css('transform', 'rotate(180deg) scale(1.75)');
                    this.glareElement.css('opacity', '' + this.settings.maxGlare / 4);
                }

                return;
            } else {
                jQuery(this).css('transform', 'perspective(' + this.settings.perspective + 'px) rotateX(' + (this.settings.axis === 'x' ? 0 : this.transforms.tiltY) + 'deg) rotateY(' + (this.settings.axis === 'y' ? 0 : this.transforms.tiltX) + 'deg) scale3d(' + this.settings.scale + ',' + this.settings.scale + ',' + this.settings.scale + ')');

                // Rotate glare if enabled
                if (this.settings.glare) {
                    this.glareElement.css('transform', 'rotate(' + this.transforms.angle + 'deg) scale(1.75)');
                    this.glareElement.css('opacity', '' + this.transforms.percentageY * this.settings.maxGlare / 100);
                }
            }

            // Trigger change event
            jQuery(this).trigger("change", [this.transforms]);

            this.ticking = false;
        };

        /**
         * Prepare elements
         */
        var prepareGlare = function prepareGlare() {

            // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
            if (this.settings.glarePrerender) return;

            // Create glare element
            jQuery(this).append('<div class="js-tilt-glare"><div class="js-tilt-glare-inner"></div></div>');

            // Store glare selector if glare is enabled
            this.glareElementWrapper = jQuery(this).find(".js-tilt-glare");
            this.glareElement = jQuery(this).find(".js-tilt-glare-inner");

            // Abstracted re-usable glare styles
            var stretch = {
                'position': 'absolute',
                'top': '0',
                'left': '0',
                'width': '100%',
                'height': '100%'
            };

            // Style glare wrapper
            this.glareElementWrapper.css(stretch).css({
                'overflow': 'hidden'
            });

            // Style glare element
            this.glareElement.css(stretch).css({
                'background-image': 'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)',
                'opacity': '' + this.settings.maxGlare / 2,
                'transform': 'rotate(180deg) scale(1.75)'
            });
        };

        /**
         * Public methods
         */
		 jQuery.fn.tilt.destroy = function () {
            jQuery(this).each(function () {
                jQuery(this).css({ 'will-change': '', 'transform': '' });
                jQuery(this).off('mousemove mouseenter mouseleave');
            });
        };

        jQuery.fn.tilt.getValues = function () {
            var results = [];
            jQuery(this).each(function () {
                this.mousePositions = getMousePositions.call(this);
                results.push(getValues.call(this));
            });
            return results;
        };

        jQuery.fn.tilt.reset = function () {
            jQuery(this).each(function () {
                var _this2 = this;

                this.mousePositions = getMousePositions.call(this);
                this.settings = jQuery(this).data('settings');
                mouseLeave.call(this);
                setTimeout(function () {
                    _this2.reset = false;
                }, this.settings.transition);
            });
        };

        /**
         * Loop every instance
         */
        return this.each(function () {
            var _this3 = this;

            /**
             * Default settings merged with user settings
             * Can be set trough data attributes or as parameter.
             * @type {*}
             */
            this.settings = jQuery.extend({
                maxTilt: jQuery(this).is('[data-tilt-max]') ? jQuery(this).data('tilt-max') : 20,
                perspective: jQuery(this).is('[data-tilt-perspective]') ? jQuery(this).data('tilt-perspective') : 300,
                easing: jQuery(this).is('[data-tilt-easing]') ? jQuery(this).data('tilt-easing') : 'cubic-bezier(.03,.98,.52,.99)',
                scale: jQuery(this).is('[data-tilt-scale]') ? jQuery(this).data('tilt-scale') : '1',
                speed: jQuery(this).is('[data-tilt-speed]') ? jQuery(this).data('tilt-speed') : '400',
                transition: jQuery(this).is('[data-tilt-transition]') ? jQuery(this).data('tilt-transition') : true,
                axis: jQuery(this).is('[data-tilt-axis]') ? jQuery(this).data('tilt-axis') : null,
                reset: jQuery(this).is('[data-tilt-reset]') ? jQuery(this).data('tilt-reset') : true,
                glare: jQuery(this).is('[data-tilt-glare]') ? jQuery(this).data('tilt-glare') : false,
                maxGlare: jQuery(this).is('[data-tilt-maxglare]') ? jQuery(this).data('tilt-maxglare') : 1
            }, options);

            this.init = function () {
                // Store settings
                jQuery(_this3).data('settings', _this3.settings);

                // Prepare element
                if (_this3.settings.glare) prepareGlare.call(_this3);

                // Bind events
                bindEvents.call(_this3);
            };

            // Init
            this.init();
        });
    };

    /**
     * Auto load
     */
	 jQuery('[data-tilt]').tilt();
	

	jQuery('[id^="tilt-"]').each(function () {
		// console.log(this.children[0]);
		/* Store the element in el */
		let holographicElement = this;

		// function updateHolographicBackground(value) {
		// 	const percentage = value * 300;
		// 	holographicElement.style.backgroundPosition = percentage + "%";
		//   }
		  
		//   function handleMouseMove(event) {
		// 	const x = event.clientX;
		// 	const width = document.documentElement.clientWidth;
		// 	const value = x / width;
		// 	updateHolographicBackground(value);
		//   }
		  
		  function handleDeviceOrientation(event) {
			const z = Math.abs(event.beta); // rotation degrees from 0 to 360
			const value = z / 180;
			updateHolographicBackground(value);
		  }
		  
		  window.addEventListener("deviceorientation", handleDeviceOrientation, true);
		//   window.addEventListener("mousemove", handleMouseMove, true);


		jQuery(holographicElement).tilt({
			scale: .95,
			glare: true,
		  	maxGlare: 0.5,
		  	maxTilt: 10,
			disableAxis:'X'
		});

		// /* Get the height and width of the element */
		// let height = 400;
		// let width = 400;

		// /*
		// * Add a listener for mousemove event
		// * Which will trigger function 'handleMove'
		// * On mousemove
		// */
		// el.addEventListener('mousemove', handleMove)

		// /* Define function a */
		// function handleMove(e) {
		// /*
		// 	* Get position of mouse cursor
		// 	* With respect to the element
		// 	* On mouseover
		// 	*/
		// /* Store the x position */
		// const xVal = e.layerX
		// /* Store the y position */
		// const yVal = e.layerY
		
		// /*
		// 	* Calculate rotation valuee along the Y-axis
		// 	* Here the multiplier 20 is to
		// 	* Control the rotation
		// 	* You can change the value and see the results
		// 	*/
		// const yRotation = 20 * ((xVal - width / 2) / width)
		
		// /* Calculate the rotation along the X-axis */
		// const xRotation = -20 * ((yVal - height / 2) / height)
		
		// /* Generate string for CSS transform property */
		// // const string = 'perspective(500px) scale(1.1) rotateX(' + xRotation + 'deg) rotateY(' + yRotation + 'deg)'
		// /* Apply the calculated transformation */
		// el.style.transform = 'perspective(500px) rotateX(' + xRotation + 'deg) rotateY(' + yRotation + 'deg)';
		// }

		// /* Add listener for mouseout event, remove the rotation */
		// el.addEventListener('mouseout', function() {
		// el.style.transform = 'perspective(500px) rotateX(0) rotateY(0)'
		// })

		// /* Add listener for mousedown event, to simulate click */
		// el.addEventListener('mousedown', function() {
		// el.style.transform = 'perspective(500px) rotateX(0) rotateY(0)'
		// })

		// /* Add listener for mouseup, simulate release of mouse click */
		// el.addEventListener('mouseup', function() {
		// el.style.transform = 'perspective(500px) rotateX(0) rotateY(0)'
		// })



		});


				
	// });
}); 